import { request_detail, request_list } from '@/commons/hpod';
import { refreshResource } from '@/commons/utils';
import Vue from 'vue';
import Crud from './crud'
var crud = new Crud('quotes', 'báo giá');

const state = {
    ...crud.state,
    selected: {
        ID: 0,
        Status: 1,
        Details: []
    },
    summary: {}
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    recalcDetail({ commit }, id) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_detail(`${crud.endpoint}/recalc`, data => {
                    resolve(data);
                    refreshResource();
                    commit("setLoading", { loading: false });
                }, Vue.http, id, this.state.authentication.token);
            }, 100)
        })
    },
    getSummary({ commit }, id) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                commit("setLoading", { loading: true });
                request_list(`${crud.endpoint}/summary`, data => {
                    resolve(data);
                    commit('setSummary', data);
                    commit("setLoading", { loading: false });
                }, Vue.http, {}, this.state.authentication.token);
            }, 100)
        })
    },
};
const mutations = {
    ...crud.mutations,
    setSummary(state, item) {
        state.summary = item.data ? item.data : item;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};